import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { modifiers, elements } from '#components/generics/js/styles.js'

const handlers = new WeakMap()
const targets = new WeakMap()
const wrappers = new WeakSet()

const onInput = object(listener, {
  type: input,
  passive,
  task: async element => {
    const target = targets.get(element)

    await handlers.get(element)?.(element, target)
  }
})

export const handle = (element, handler) => {
  const wrapper = closest(`[data-contract~="timeSelect.wrapper"]`, element)
  const select = one(`.${elements.new_field_select}`, wrapper)
  const fieldTime = one(`.${modifiers.new_field.new_time}`, wrapper)

  if (!wrappers.has(wrapper)) {
    return
  }

  if (element === select) {
    targets.set(element, fieldTime)
  } else {
    targets.set(element, select)
  }

  handlers.set(element, handler)
  onInput.listen(element)

  queueMicrotask(async () => {
    await removed(element)
    handlers.delete(element)
    targets.delete(element)
  })
}

export default wrapper => {
  wrappers.add(wrapper)

  queueMicrotask(async () => {
    await removed(wrapper)
    wrappers.delete(wrapper)
  })
}